var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-10" }, [
    _c(
      "div",
      { staticClass: "p-30 bg-white flex justify-center" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            staticStyle: { width: "500px" },
            attrs: { model: _vm.userForm, "label-width": "80px" },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "头像：" } },
              [
                _c("upload", {
                  attrs: { "file-list": _vm.fileList, ratio: "1:1" },
                  on: { fileOk: _vm.fileOk },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "姓名" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.userForm.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.userForm, "name", $$v)
                    },
                    expression: "userForm.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "手机号" } },
              [
                _c("el-input", {
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.userForm.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.userForm, "phone", $$v)
                    },
                    expression: "userForm.phone",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "身份证号" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.userForm.id_card,
                    callback: function ($$v) {
                      _vm.$set(_vm.userForm, "id_card", $$v)
                    },
                    expression: "userForm.id_card",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "银行卡号" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.userForm.bank_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.userForm, "bank_id", $$v)
                    },
                    expression: "userForm.bank_id",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "所属银行" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.userForm.bank_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.userForm, "bank_name", $$v)
                    },
                    expression: "userForm.bank_name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "所属分行" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.userForm.bank_branch_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.userForm, "bank_branch_name", $$v)
                    },
                    expression: "userForm.bank_branch_name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.editUser()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }